import React from "react";
import {Typography} from "@mui/material";
import moment from "moment/moment";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import {COMPACT_TIME_FORMAT} from "../../../config/DateTimeConstants";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function PerformerJoinedHealth({session, state}) {

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("performer-joined-session");

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2" sx={{mr: '-0.25rem'}}>Performer joined</Typography>
          {
            session?.actualSessionStartTime
            && <Typography variant="body2">{`(${moment(session.actualSessionStartTime).format(COMPACT_TIME_FORMAT)})`}</Typography>
          }
          {
            !session?.actualSessionStartTime
            && <Typography variant="body2">(N/A)</Typography>
          }
      </CenteredBox>
    );
}